import React, { Component } from 'react';
import PropTypes from 'prop-types';
import LazyImage from 'dibs-react-lazy-image';
import { TrackingCarousel } from '../../components/global/TrackingCarousel';
import {
    trackInitialDisplay,
    trackArrowClick,
    trackItemClick,
    trackRecentItems,
} from 'dibs-recent-history/exports/recentHistoryTracking';
import {
    HORIZONTAL_OFFSET_RESP_IMG,
    VERTICAL_OFFSET_RESP_IMG,
    SRC_SET_SIZES_RESP_RECENTLY_VIEWED_TILE,
} from '../../constants/imageConstants';
import { getSrcSetString } from 'dibs-search-product-tile/exports/srcSetHelpers';

class SharedRecentlyViewedItemsCarousel extends Component {
    constructor() {
        super();

        this.handleInitialDisplay = this.handleInitialDisplay.bind(this);
        this.renderCarouselItem = this.renderCarouselItem.bind(this);
    }

    handleInitialDisplay() {
        const { items } = this.props;
        const itemsReturned = items.length;
        trackInitialDisplay({ itemsReturned });
    }

    handleItemClick({ item, index }) {
        trackItemClick();
        trackRecentItems({
            type: 'productClick',
            items: [item],
            startIndex: index + 1, // Tracking needs non zero index position.
            variant: 'products',
        });
    }

    handleItemImpression({ item, index }) {
        trackRecentItems({
            type: 'productImpression',
            items: [item],
            startIndex: index + 1, // Tracking needs non zero index position.
            variant: 'products',
        });
    }

    renderCarouselItem({ index }) {
        const { items, classNames } = this.props;
        const item = items[index];
        const itemImageUrlSrc = item.itemImageUrl?.src || item.itemImageUrl;

        const srcSetAttributes = itemImageUrlSrc
            ? {
                  srcSet: getSrcSetString(itemImageUrlSrc),
                  sizes: SRC_SET_SIZES_RESP_RECENTLY_VIEWED_TILE,
              }
            : {};

        return (
            <a
                key={`recent-${item.itemId}`}
                href={item.itemPdpUrl}
                onClick={() => this.handleItemClick({ item, index })}
                className={classNames.itemLink}
                data-tn="recently-viewed-link"
            >
                <LazyImage
                    offsetHorizontal={HORIZONTAL_OFFSET_RESP_IMG}
                    offsetVertical={VERTICAL_OFFSET_RESP_IMG}
                    placeholderClass={classNames.placeholder}
                    className={classNames.placeholder}
                >
                    <img
                        className={classNames.itemImage}
                        src={itemImageUrlSrc}
                        alt={item.itemTitle}
                        {...srcSetAttributes}
                    />
                </LazyImage>
            </a>
        );
    }

    render() {
        const { items, itemsPerPage, classNames } = this.props;

        return (
            <TrackingCarousel
                items={items}
                classNames={classNames}
                dataTn="recently-viewed-carousel"
                renderItem={this.renderCarouselItem}
                itemsPerPage={itemsPerPage}
                onInitialDisplay={this.handleInitialDisplay}
                onItemImpression={this.handleItemImpression}
                onNextPage={() => trackArrowClick({ direction: 'right' })}
                onPreviousPage={() => trackArrowClick({ direction: 'left' })}
            />
        );
    }
}

SharedRecentlyViewedItemsCarousel.propTypes = {
    items: PropTypes.arrayOf(
        PropTypes.shape({
            contemporaryTrackingString: PropTypes.string,
            itemTitle: PropTypes.string.isRequired,
            itemId: PropTypes.string.isRequired,
            itemBrowseUrl: PropTypes.string,
            itemCategoryCode: PropTypes.string,
            itemImageUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
            itemPdpUrl: PropTypes.string.isRequired,
            dealerPk: PropTypes.string.isRequired,
            category: PropTypes.string.isRequired,
        })
    ).isRequired,
    itemsPerPage: PropTypes.number.isRequired,
    classNames: PropTypes.shape({
        list: PropTypes.string,
        placeholder: PropTypes.string.isRequired,
        itemLink: PropTypes.string.isRequired,
        itemImage: PropTypes.string.isRequired,
    }).isRequired,
};

export { SharedRecentlyViewedItemsCarousel };
